module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAATCAYAAACk9eypAAAA/UlEQVQokXXTPyjEYRzH8dfvGJSUbAYDZVHGWywWk+k24xHTLepKSimllJRYTEIm400Wk5LFeIPBcIPBJiVF+Tfc/ern6/l9t+f9+b6ffz1PNnHTucCCv9VGFR+Bq6CBp8CnsRWbc+EZK4lsDTMpAS5xHLI+nGEwJUATnSBNYrdMeMUSvoPUwFxKgGscBpbhBMMpATZwH9gYDsqEd9TxGXgdtZQAd2gl+HaZUEUtwTdTwoDu/fcHfo5WStjBVGCPWOX/oWfzoFA/WMZLFIZwmpjkCFf5oBjuYzw0P2C9CHJhvrdssb6wiLcojOi+1CwIe7gNTKW3x9HA20o+0C+hKCvrvEdxqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/icon2.png
// module id = h2uk
// module chunks = 1